// @flow
import React from 'react';
import {connect} from 'react-redux';

import Filters from '@homeaway/react-search-filters';
import FilteredCountDataProvider from '../FilteredCountDataProvider/FilteredCountDataProvider';

import {media} from '../../utils/breakpoints';

import routerActions from '../../actions/router';
import searchParamsActions from '../../actions/searchParams';

import type {State as ReduxState} from '../../reducers/index';
import type {SearchParamsType} from '../../reducers/searchParams';
import type {FilterGroupType} from '@homeaway/react-search-filters';

import {getLengthOfStay} from '../../utils/filters';
export type FilterDispatchProps = {
    onDone: typeof routerActions.filter,
    onDismiss: typeof searchParamsActions.syncInputParams,
    onFilterToggle: typeof searchParamsActions.updateFilterCheck,
    onMultipleFilterToggle: typeof searchParamsActions.updateMultipleFilterCheck,
    onCustomFilterUpdate: typeof searchParamsActions.updateInputParams,
    updatePriceInputValuesValidity: typeof searchParamsActions.updatePriceInputValuesValidity
};

export type FilterProps = {
    allFiltersButtonOnly?: Boolean,
    allFiltersButtonCustomTrigger?: Element,
    displayMoreFiltersPillLeft?: boolean,
    displayNumGroupsAsPills?: ?number,
    currency: string,
    hasDates: boolean,
    isMobile: boolean,
    lengthOfStay?: ?number,
    locale: string,
    priceInputValuesAreValid: boolean,
    filterGroups: FilterGroupType[],
    params: SearchParamsType,
    inputParams: SearchParamsType,
    showAllFiltersPill?: boolean,
    showMoreFiltersPill?: boolean,
    searchResultsLoading: boolean
};

export type FilterContainerProps = FilterProps & FilterDispatchProps;

export function FiltersContainer(props: FilterContainerProps) {
    return (
        <Filters
            {...props}
            filterGroups={props.filterGroups ? props.filterGroups : []}
            filterCountDataProvider={FilteredCountDataProvider}
            priceFilterOptions={{
                isFilterByTotalPriceEnabled: props.hasDates,
                lengthOfStay: props.lengthOfStay,
                showFilterByPriceType: true
            }}
        />
    );
}

export const mapStateToProps = (state: ReduxState) => {
    // select params that only apply to this component
    const {
        searchParams: {inputParams, params, priceInputValuesAreValid},
        system: {currency, fullLocale: locale},
        viewport: {breakpoint}
    } = state;

    const hasDates = !!(inputParams.arrival && inputParams.departure);

    return {
        appliedFilters: params.filter,
        currency,
        customFiltersParams: {
            appliedFilterByTotalPrice: hasDates && params.filterByTotalPrice,
            appliedMaxNightlyPrice: params.maxNightlyPrice,
            appliedMaxTotalPrice: params.maxTotalPrice,
            appliedMinBathrooms: params.minBathrooms,
            appliedMinBedrooms: params.minBedrooms,
            appliedMinNightlyPrice: params.minNightlyPrice,
            appliedMinTotalPrice: params.minTotalPrice,
            selectedFilterByTotalPrice:
                hasDates && inputParams.filterByTotalPrice,
            selectedMaxNightlyPrice: inputParams.maxNightlyPrice,
            selectedMaxTotalPrice: inputParams.maxTotalPrice,
            selectedMinBathrooms: inputParams.minBathrooms,
            selectedMinBedrooms: inputParams.minBedrooms,
            selectedMinNightlyPrice: inputParams.minNightlyPrice,
            selectedMinTotalPrice: inputParams.minTotalPrice
        },
        hasDates,
        isMobile: !media(breakpoint, {minWidth: 'SM_MIN'}),
        lengthOfStay: getLengthOfStay(
            inputParams.arrival,
            inputParams.departure
        ),
        locale,
        priceInputValuesAreValid,
        selectedFilters: inputParams.filter
    };
};

export const mapDispatchToProps = {
    onClear: searchParamsActions.clearFilters,
    onCustomFilterUpdate: searchParamsActions.updateInputParams,
    onDone: routerActions.filter,
    onDismiss: searchParamsActions.syncInputParams,
    onFilterToggle: searchParamsActions.updateFilterCheck,
    onMultipleFilterToggle: searchParamsActions.updateMultipleFilterCheck,
    updatePriceInputValuesValidity:
        searchParamsActions.updatePriceInputValuesValidity
};

const ConnectedFiltersContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FiltersContainer);

export default ConnectedFiltersContainer;
